import { UIComponentCSSStyle, UIComponentCSSStyleImpl } from '../../../../../toolkit/uicomponentcss';
import { Fonts } from '../../../../../../utils/resources/fonts';
import { Colors } from '../../../../../../utils/resources/colors';
import { LanguageConst } from 'src/com/sixdee/crbtportal/utils/resources/languageconst';
export interface ToneCardCSSStyle extends UIComponentCSSStyle
{
    getToneWrapperCSSStyle(marginTop: string): object;
    getImgCSSStyle(): object;
    getOnHoverCSSStyle(): object;
    getToneNameCSSStyle(): object;
    getButtonCSSStyle(): object;
    getArtistNameCSSStyle(): object;
    getDetailsDivCssStyle(): object;
    getTitleDivCSSStle(): object;

    getHeartDivCSSStyle(): object;
    getAnnounceDivCSSStyle():object;
    getShareDivCSSStyle():object;
    getActionDivCSSStyle(): object;
    getActionCSSStyle(): object;
    getDropDownSSStyle(): object; 
    getExtraActionDivCSSStyle(width: string): object;



    getMobileToneWrapperCSSStyle(marginTop: string): object;
    getMobileImgCSSStyle(): object;
    getMobileOnHoverCSSStyle(): object;
    getMobileToneNameCSSStyle(): object;
    getMobileButtonCSSStyle(): object;
    getMobileArtistNameCSSStyle(): object;
    getMobileDetailsDivCssStyle(): object;
    getMobileTitleDivCSSStle(): object;

    getMobileHeartDivCSSStyle(): object;
    getMobileAnnounceDivCSSStyle():object;
    getMobileShareDivCSSStyle():object;
    getMobileActionDivCSSStyle(): object;
    getMobileActionCSSStyle(): object;
    getMobileDropDownSSStyle(): object; 
    getMobileExtraActionDivCSSStyle(width: string): object;
}

export class ToneCardCSSStyleImpl extends UIComponentCSSStyleImpl implements ToneCardCSSStyle
{
    getToneWrapperCSSStyle(marginTop: string): object
    {
        return {
            // height: '340px', 
            // width: '262px', 
            // // marginRight: "40px",
            // marginTop: marginTop,
            objectFit: 'cover', 
            position: 'relative',
            cursor: "pointer",
            borderRadius:'50px 0px 50px 0px'
        };
    }

    getOnHoverCSSStyle(): object 
    {
        return {
            objectFit: 'cover', 
            position: 'absolute',
            // height: '280px', 
            // width: '262px', 
            // borderRadius:'50px 0px 50px 0px',
            display: "flex",
            // paddingLeft: "20px",
            // paddingRight: "20px",
            // paddingTop: "20px",
            background: "linear-gradient(0deg, #000000 0%, rgba(0,0,0,0.73) 100%)"
        };
    }

    getImgCSSStyle(): object 
    {
        return {
            objectFit: 'cover', 
            width: '100%', 
            height: '280px',
            borderRadius: "50px 0px 50px 0px",
        };
    }

    getDetailsDivCssStyle(): object 
    {
        return {
            objectFit: 'cover', 
            // height: '60px',
            display: "flex",
            position: "relative",
            flexDirection: "row",
            flexFlow: "row wrap",
            backgroundColor: this.getResources().getColor(Colors.color_5)
        };
    }

    getTitleDivCSSStle(): object 
    {
        return {
            // height: '50px',
            flex: 0.5,
        };
    }

    getToneNameCSSStyle(): object {
        return {
            // textAlign:"left",
            // height: '30px',
            // fontWeight: 'bold',
            // width: "172px",
            // letterSpacing: 0,
            // fontSize: this.getResources().getFont(Fonts.h9),
            color:this.getResources().getColor(Colors.color_4),
            fontFamily: this.getResources().getFontFamily(),
            // lineHeight: "30px",
            // position: 'relative', 
            // alignItems: 'left', 
            // justifyContent: 'left', 
            // top: 0,
            // overflow: 'hidden',
            // textOverflow: 'ellipsis',
        };
    }

    getArtistNameCSSStyle(): object {
        return {
            
            // textAlign:"left",
            // height: '20px',
            // // fontWeight: "500",
            // letterSpacing: 0,
            // width: "172px",
            // overflow: 'hidden',
            // textOverflow: 'ellipsis',
            // fontSize: this.getResources().getFont(Fonts.h8),
            color:this.getResources().getColor(Colors.color_35),
            fontFamily: this.getResources().getFontFamily(),
            // lineHeight: "20px",
            // position: 'relative', 
            // alignItems: 'center', 
            // justifyContent: 'center', 
            // top: 0,
        };
    }

    getButtonCSSStyle(): object 
    {
        return {
            // height: "28px",
            // width: "68px", 
            // marginTop: "32px",
            display:'flex'
        };
    }

    getTitleCSSStyle(): object {
        return {
            display: "flex",
            textAlign: "center",
            width: '100%', 
            height: '29px',
            fontWeight: "900",
            letterSpacing: 0,
            fontSize: this.getResources().getFont(Fonts.h6),
            color:this.getResources().getColor(Colors.color_9),
            fontFamily: this.getResources().getFontFamily(),
            lineHeight: "20px",
            position: 'relative', 
            alignItems: 'center', 
            justifyContent: 'center', 
            top: 0,
        };
    }

    getActionCSSStyle(): object 
    {
        return {
            height: "25px",
            width: "21.5px",
        };
    }

    getDropDownSSStyle(): object 
    {
        return {
            display: "flex",
            width: "151px",
            marginTop: "4.5px",
            position: "absolute",
            zIndex: 2,
            marginLeft:this.getContext().getUserContext().getLanguage() === LanguageConst.FRENCH? "31%":"0%",
            marginRight:this.getContext().getUserContext().getLanguage() === LanguageConst.FRENCH?"0%":"31%",
            borderRadius:'25.5px',
            // border: '1px solid #EAECEF',
            backgroundColor: this.getResources().getColor(Colors.color_5)
        };
    }

    getExtraActionDivCSSStyle(width: string): object 
    {
        return {
            width: width, 
            display: "inline-block", 
            // alignItems: 'right', 
            // justifyContent: 'flex-end',   
            // textAlign: "right",
            height: "50px",
            // marginRight:'7px'
        };
    }

    
    getHeartDivCSSStyle(): object {
        return {
            // width: "30%", 
            // display: "inline-block", 
            // alignItems: 'left', 
            // justifyContent: 'flex-start',   
            // textAlign: "left",
            // height: "50px",
            // marginLeft:'7px'
        };
    }

    getAnnounceDivCSSStyle(): object {
        return {
            width: "35%", 
            display: "inline-block", 
            alignItems: 'center', 
            justifyContent: 'flex-center',   
            textAlign: "center",
            height: "50px",
        };
    }

    getShareDivCSSStyle(): object {
        return {
            width: "30%", 
            display: "inline-block", 
            alignItems: 'right', 
            justifyContent: 'flex-end',   
            textAlign: "right",
            height: "50px",
            marginRight:'7px'

        };
    }
    getActionDivCSSStyle(): object {
        return {
            height: "35px",
        };
    }








    getMobileToneWrapperCSSStyle(marginTop: string): object
    {
        return {
            height: '140px', 
            width: '131px', 
            marginTop: "70px",
            objectFit: 'cover', 
            position: 'relative',
            cursor: "pointer",
            borderRadius:'25px 0px 25px 0px'
        };
    }

    getMobileOnHoverCSSStyle(): object 
    {
        return {
            objectFit: 'cover', 
            position: 'absolute',
            height: '140px', 
            width: '131px', 
            borderRadius:'25px 0px 25px 0px',
            display: "flex",
            paddingLeft: "10px",
            paddingRight: "10px",
            paddingTop: "20px",
            background: "linear-gradient(0deg, #000000 0%, rgba(0,0,0,0.73) 100%)"
        };
    }

    getMobileImgCSSStyle(): object 
    {
        return {
            objectFit: 'cover', 
            width: '100%', 
            height: '140px',
            borderRadius: "25px 0px 25px 0px",
        };
    }

    getMobileDetailsDivCssStyle(): object 
    {
        return {
            objectFit: 'cover', 
            height: '30px',
            display: "flex",
            position: "relative",
            flexDirection: "row",
            flexFlow: "row wrap",
            backgroundColor: this.getResources().getColor(Colors.color_5)
        };
    }

    getMobileTitleDivCSSStle(): object 
    {
        return {
            height: '30px',
            // flex: 1,
            width:"auto"
        };
    }

    getMobileToneNameCSSStyle(): object {
        return {
            textAlign:"left",
            height: '20px',
            fontWeight: 'bold',
            width: "90px",
            letterSpacing: 0,
            fontSize: "12px",
            color:this.getResources().getColor(Colors.color_4),
            fontFamily: this.getResources().getFontFamily(),
            lineHeight: "20px",
            position: 'relative', 
            alignItems: 'left', 
            justifyContent: 'left', 
            top: 0,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
        };
    }

    getMobileArtistNameCSSStyle(): object {
        return {
            
            textAlign:"left",
            height: '15px',
            // fontWeight: "500",
            letterSpacing: 0,
            width: "90px",
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            fontSize: "9px",
            color:this.getResources().getColor(Colors.color_35),
            fontFamily: this.getResources().getFontFamily(),
            lineHeight: "15px",
            position: 'relative', 
            alignItems: 'center', 
            justifyContent: 'center', 
            top: 0,
        };
    }

    getMobileButtonCSSStyle(): object 
    {
        return {
            height: "12px",
            width: "34px", 
            marginTop: "22px",
            display:'flex'
        };
    }

    getMobileTitleCSSStyle(): object {
        return {
            display: "flex",
            textAlign: "center",
            width: '100%', 
            height: '13px',
            fontWeight: "900",
            letterSpacing: 0,
            fontSize: "9px",
            color:this.getResources().getColor(Colors.color_9),
            fontFamily: this.getResources().getFontFamily(),
            lineHeight: "13px",
            position: 'relative', 
            alignItems: 'center', 
            justifyContent: 'center', 
            top: 0,
        };
    }

    getMobileActionCSSStyle(): object 
    {
        return {
            height: "14.5px",
            width: "10.5px",
        };
    }

    getMobileDropDownSSStyle(): object 
    {
        return {
            display: "flex",
            minWidth: "120px",
            marginTop: "-4px",
            position: "absolute",
            zIndex: 20,
            marginLeft:this.getContext().getUserContext().getLanguage() === LanguageConst.FRENCH? "-3%":"3%",
            marginRight:this.getContext().getUserContext().getLanguage() === LanguageConst.FRENCH?"0%":"-3%",
            borderRadius:'25.5px',
            // border: '1px solid #EAECEF',
            backgroundColor: this.getResources().getColor(Colors.color_5)
        };
    }

    getMobileExtraActionDivCSSStyle(width: string): object 
    {
        return {
            // width: "30%", 
            display: "inline-block", 
            // alignItems: 'right', 
            // justifyContent: 'flex-end',   
            // textAlign: "right",
            height: "30px",
            // marginRight:'7px',
            marginLeft:this.getContext().getUserContext().getLanguage() === LanguageConst.FRENCH?'auto':"0px",
            marginRight:this.getContext().getUserContext().getLanguage() === LanguageConst.FRENCH?"0px":"auto",
        };
    }

    
    getMobileHeartDivCSSStyle(): object {
        return {
            // width: "30%", 
            // display: "inline-block", 
            // alignItems: 'left', 
            // justifyContent: 'flex-start',   
            // textAlign: "left",
            // height: "30px",
            // marginLeft:'0px'
        };
    }

    getMobileAnnounceDivCSSStyle(): object {
        return {
            width: "19%", 
            display: "inline-block", 
            alignItems: 'center', 
            justifyContent: 'flex-center',   
            textAlign: "center",
            height: "30px",
            marginLeft:'15px'
        };
    }

    getMobileShareDivCSSStyle(): object {
        return {
            width: "15%", 
            display: "inline-block", 
            marginLeft:'15px',

            alignItems: 'right', 
            justifyContent: 'flex-end',   
            textAlign: "right",
            height: "30px",
            marginRight:'7px'

        };
    }
    getMobileActionDivCSSStyle(): object {
        return {
            height: "17px",
        };
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/featuredcategory/viewmodel/tonecard/tonecardcssstyle.tsx